/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataRemovalRequestDataDecisionSourceSchema = z.enum(['manual', 'auto'])

export type DataRemovalRequestDataDecisionSourceSchema = z.infer<typeof dataRemovalRequestDataDecisionSourceSchema>
